import type { ReactNode } from 'react'
import { useTheme } from 'styled-components'

import { Typography } from '../../../Typography'

import {
  StyledHighlight,
  StyledIconWrapper,
  StyledWrapper,
} from './Highlight.Styled'

export type HighlightProps = {
  title: string
  subtitle: string
  icon: ReactNode
}

export const Highlight = ({ title, subtitle, icon }: HighlightProps) => {
  const theme = useTheme()
  return (
    <StyledWrapper>
      <StyledIconWrapper>{icon}</StyledIconWrapper>
      <StyledHighlight>
        <Typography
          $color={theme.colors['N Content/Primary']}
          $variant="Poppins/T2 - Medium"
        >
          {title}
        </Typography>
        <Typography
          $color={theme.colors['N Content/Secondary']}
          $variant="Poppins/T3"
        >
          {subtitle}
        </Typography>
      </StyledHighlight>
    </StyledWrapper>
  )
}
